import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import axiosInstance from 'services/api/axiosInstance'

const Help = () => {
    const [helpVideosData, setHelpVideosData] = useState([]);
    const [initialGlow, setInitialGlow] = useState(false);

    useEffect(() => {
        setInitialGlow(true)

        const getHelpVideos = async () => {
            try {
                const { data } = await axiosInstance.get('/get_help_videos_details');
                if (data?.error_code === 200) {
                    setInitialGlow(false)
                    setHelpVideosData(data?.data)
                } else {
                    setInitialGlow(false)
                    setHelpVideosData([])
                }
            } catch (Err) {
                setInitialGlow(false)
                setHelpVideosData([])
                console.log(Err?.message)
            }
        }

        getHelpVideos()
    }, [])

    return (
        <div className="professional-home-page-bg overflow-hidden placeholder-glow">
            <div className="professional-home-page-padding">
                <div className="container">
                    <div className="py-4">
                        <h5 className='mb-3'>Help Videos</h5>
                        <div className="row gy-3">
                            {
                                initialGlow ?
                                    Array.from({ length: 6 })?.map((__, i) => (
                                        <div className="col-12 col-mg-6 col-lg-4" key={i}>
                                            <Card className='border-0 shadow rounded-4'>
                                                <Card.Body className=''>
                                                    <div className="w-100 professional-help-video-placeholder placeholder rounded-3">
                                                    </div>
                                                    <h6 className='placeholder p-3 mt-2 col-8 rounded-2'></h6>
                                                    <p className='placeholder p-3 col-10 rounded-2'></p>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    ))
                                    :
                                    helpVideosData?.map((value, index) => (
                                        <div className="col-12 col-mg-6 col-lg-4" key={index}>
                                            <Card className='border-0 shadow rounded-4 h-100'>
                                                <Card.Body className=''>
                                                    <div className="w-100 professional-help-video">
                                                        <div dangerouslySetInnerHTML={{ __html: value?.url }}></div>
                                                    </div>
                                                    <h6 className='mt-3'>{value?.title}</h6>
                                                    <p className='text-secondary mb-0'>{value?.description}</p>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Help